import React, { useState } from 'react';
import { Field, ErrorMessage, useField } from 'formik';
import TextareaAutosize from 'react-textarea-autosize';

import {
    input,
    labelText,
    hint as hintClass,
    dropdown,
    hintIcon,
    labelBox,
    inputBox,
    maxLength,
} from './input.module.scss';

import TextError from './text-error';
import Dropdown from '../../molecules/dropdown';

const Input = ({
    label,
    name,
    hint,
    containerClass = '',
    as,
    id,
    rows = 2,
    inputClassname = '',
    identifier = '',
    showError = true,
    labelClassName = '',
    labelBoxClassName = '',
    ...rest
}) => {
    const [, meta] = useField(name);
    const [isHintHovered, setIsHintHovered] = useState(false);

    const InputBoxTag = rest.maxLength ? 'div' : React.Fragment;
    const inputBoxTagProps = rest.maxLength ? { className: inputBox } : {};

    return (
        <div className={containerClass}>
            <div className={`${labelBox} ${labelBoxClassName}`}>
                {label && (
                    <label
                        htmlFor={`${name}${identifier}`}
                        className={`${labelText} ${labelClassName}`}
                    >
                        {label}
                    </label>
                )}
                {hint && (
                    <button
                        className={hintClass}
                        onMouseEnter={() => setIsHintHovered(true)}
                        onMouseLeave={() => setIsHintHovered(false)}
                        type="button"
                        tabIndex="-1"
                    >
                        <span className={hintIcon}>i</span>
                        <Dropdown open={isHintHovered} className={dropdown}>
                            {hint}
                        </Dropdown>
                    </button>
                )}
            </div>
            <InputBoxTag {...inputBoxTagProps}>
                <Field
                    as={as === 'textarea' ? TextareaAutosize : as}
                    {...(as === 'textarea' ? { minRows: rows } : {})}
                    id={id ? id : `${name}${identifier}`}
                    name={name}
                    className={`${input} ${inputClassname}`}
                    {...rest}
                />
                {rest.maxLength && (
                    <p className={maxLength}>
                        {meta.value?.length || 0}/{rest.maxLength}
                    </p>
                )}
            </InputBoxTag>
            {showError ? <ErrorMessage name={name} component={TextError} /> : null}
        </div>
    );
};

export default Input;
